import { hubQueryKeys } from "@lifter/hub-ui/browser-shared";
import { useQuery } from "@tanstack/react-query";
import { type AgentQueryOptions, useHubApi } from "./context";

export function useDashboardActivityTodayQuery(options: AgentQueryOptions = {}) {
  const api = useHubApi();
  return useQuery({
    queryKey: hubQueryKeys.dashboardActivityToday(),
    queryFn: () => api.dashboard.activityToday(),
    enabled: options.enabled ?? true,
  });
}
